export enum ItemShuffle {
  Normal,
  Keysanity,
  Retro
}
